import React from 'react';

const ArrowDownIcon = () => {
  return (
    <svg
      width={'20px'}
      height={'20px'}
      viewBox="0 0 31 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.36719 2.13477L14.7927 14.5603C14.8834 14.6569 14.9929 14.7339 15.1146 14.7866C15.2362 14.8392 15.3673 14.8664 15.4998 14.8664C15.6324 14.8664 15.7635 14.8392 15.8851 14.7866C16.0067 14.7339 16.1163 14.6569 16.207 14.5603L28.6325 2.13477"
        stroke="white"
        strokeWidth="3.42857"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default ArrowDownIcon